import React from 'react';
import { SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="bg-graphite px-4 py-8 sm:px-6" data-id="element-85" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl" data-id="element-86" data-mp="3ggk7utmc79z0">
        <h2 className="text-base font-extrabold text-white sm:text-lg" data-id="element-87" data-mp="32oe3e4sjqrfe">Orthophonie Pro™</h2>
        <p className="mt-2 text-[13px] leading-snug text-white/70 sm:text-sm" data-id="element-88" data-mp="36p6d0z5byyc7">
          Le système professionnel complet pour les orthophonistes qui veulent disposer de ressources
          structurées, adaptables et organisées. Parce qu’un professionnel expérimenté ne devrait pas
          avoir à reconstruire ses outils et ses séances à partir de zéro chaque semaine.
        </p>
        <p className="mt-3 text-[13px] text-white/70 sm:text-sm" data-id="element-89" data-mp="3lgos8uqd8oui">
          Support :{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-gold underline" data-id="element-90" data-mp="3qf9q4ni5awfs">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-3 text-[11px] text-white/50" data-id="element-91" data-mp="2eyt7ymf7i1p8">
          © 2026 Kit Online — Tous droits réservés.
        </p>
        <p className="mt-2 text-[11px] leading-snug text-white/45" data-id="element-92" data-mp="3lalf9cv8a1sw">
          Les ressources proposées sont destinées à soutenir l’organisation de la pratique
          professionnelle. Elles ne remplacent pas le bilan orthophonique, le raisonnement clinique,
          les outils validés, les recommandations applicables ni le jugement professionnel.
          L’orthophoniste reste responsable de la sélection et de l’adaptation des ressources aux
          besoins individuels de chaque patient.
        </p>
        <ul className="mt-3 flex flex-wrap gap-x-3 gap-y-1 text-[11px] font-semibold text-white/60" data-id="element-93" data-mp="335tdib8plh0">
          <li data-id="element-94" data-mp="hsabz0ly5rpn">
            <a href="#offre" className="hover:text-gold" data-id="element-95" data-mp="hs1wd0yfw8ar">
              Conditions Générales
            </a>
          </li>
          <li aria-hidden="true" data-id="element-96" data-mp="qthx0gzgcw1s">·</li>
          <li data-id="element-97" data-mp="qujlbn5hbf1g">
            <a href="#offre" className="hover:text-gold" data-id="element-98" data-mp="qub4xla5drli">
              Politique de Confidentialité
            </a>
          </li>
          <li aria-hidden="true" data-id="element-99" data-mp="mq3glp7lqdnt">·</li>
          <li data-id="element-100" data-mp="tvw66chqp7dv">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-gold" data-id="element-101" data-mp="tw5xc3eitkl5">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </footer>;
}